import React, { useEffect, useContext } from "react";
// import React,  from "react";
import { makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import CartWidget from "../components/Cart/CartWidget";
import LanguageIcon from "@mui/icons-material/Language";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import MailIcon from "@mui/icons-material/Mail";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import FilterFramesIcon from "@mui/icons-material/FilterFrames";
import HomeIcon from "@mui/icons-material/Home";
import Login from "@mui/icons-material/Login";
// import jwt_decode from "jwt-decode";
import { Context } from "../context/ContextProvider";
// import {useNavigate} from "react-router-dom";
import jwt_decode from "jwt-decode";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // paddingBottom: 100,
  },
  menuButton: {
    // margin: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function ButtonAppBar({ t, i18n, changeLanguage }) {
  let navigate = useNavigate();

  const classes = useStyles();
  // let history = useNavigate();

  const { setValues } = useContext(Context);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <AppBar position="fixed" style={{ background: "#000000" }}>
        <Toolbar className={classes.menuButton}>
          <Tooltip title="">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              {/* <Avatar sx={{ width: 32, height: 32 }}>M</Avatar> */}
              <MenuIcon style={{ color: "white" }} />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 3,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: i18n.language === "ar" ? 0 : 1,
                  mr: i18n.language !== "ar" ? -0.5 : 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  left: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {localStorage.getItem("Token") != null ? (
              <MenuItem onClick={() => {}}>
                <Avatar />
                {jwt_decode(localStorage.getItem("Token")).user === undefined
                  ? jwt_decode(localStorage.getItem("Token")).company
                      .companyName
                  : jwt_decode(localStorage.getItem("Token")).user !== undefined
                  ? jwt_decode(localStorage.getItem("Token")).user.displayName
                  : ""}
              </MenuItem>
            ) : null}
            <MenuItem onClick={() => handleClose() & navigate("/home")}>
              <Avatar>
                <HomeIcon />
              </Avatar>
              الصفحة الرئيسية
            </MenuItem>
            {localStorage.getItem("Token") != null &&
            jwt_decode(localStorage.getItem("Token")).user === undefined ? (
              <MenuItem
                onClick={() => handleClose() & navigate("/add-product")}
              >
                <Avatar>
                  <HomeIcon />
                </Avatar>
                إضافة منتج
              </MenuItem>
            ) : null}
            <Divider />
            {localStorage.getItem("Token") != null && (
              <MenuItem onClick={() => navigate("/orders-naem")}>
                <ListItemIcon>
                  <FilterFramesIcon fontSize="small" />
                </ListItemIcon>
                الطلبات
              </MenuItem>
            )}
            <MenuItem
              onClick={() => window.open(`mailto:useaterapp@gmail.com`)}
            >
              <ListItemIcon>
                <MailIcon fontSize="small" />
              </ListItemIcon>
              {t("contactUs")}
            </MenuItem>
            <MenuItem onClick={() => navigate(`/policy`)}>
              <ListItemIcon>
                <VerifiedUserIcon fontSize="small" />
              </ListItemIcon>
              {t("privacy")}
            </MenuItem>
            <MenuItem
              onClick={() =>
                i18n.language === "ar"
                  ? changeLanguage("en")
                  : changeLanguage("ar") &
                    console.log("test", i18n.language === "ar")
              }
            >
              <ListItemIcon>
                <LanguageIcon fontSize="small" />
              </ListItemIcon>
              {i18n.language === "ar" ? "English" : "العربية"}
            </MenuItem>
            {localStorage.getItem("Token") != null && (
              <MenuItem
                onClick={() =>
                  localStorage.removeItem("Token") &
                  setValues(null) &
                  navigate("/login")
                }
              >
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                تسجيل خروج
              </MenuItem>
            )}
            {localStorage.getItem("Token") === null && (
              <MenuItem onClick={() => navigate("/login-merchant")}>
                <ListItemIcon>
                  <Login fontSize="small" />
                </ListItemIcon>
                تسجيل دخول
              </MenuItem>
            )}
          </Menu>

          <Typography className={classes.title}>{"STORE"}</Typography>
          <CartWidget />
        </Toolbar>
      </AppBar>
    </div>
  );
}




// @emotion/react@^11.10.5 @emotion/styled@^11.10.5 @fingerprintjs/fingerprintjs@^3.3.6 @mui/icons-material@^5.10.9 @mui/joy@^5.0.0-alpha.63 @mui/material@^5.10.11 @mui/styles@^5.10.10 axios@^1.1.3 i18next@^22.0.3 i18next-browser-languagedetector@^7.0.0 jss-rtl@^0.3.0 jwt-decode@^3.1.2 lottie-react@^2.3.1 prop-types@^15.6.1 react-apple-pay-button@^0.0.1-alpha.0 react-i18next@^12.0.0 react-list@^0.8.8 react-multi-carousel@^2.8.2 react-router-dom@^6.4.2 react-share@^4.4.1 react-store-badges@^1.5.1 semantic-ui-css@^2.5.0 semantic-ui-react@^2.1.3 socket.io-client@^4.5.3 styled-components@^5.3.8 stylis@^4.1.3 stylis-plugin-rtl@^2.1.1 ua-parser-js@^1.0.32 use-sound@^4.0.1 